import React from 'react';
import { View, Text } from 'react-native';

import { scale } from '@components/frame';
import { isWeb } from '@helpers';

import { font } from '@styles/fonts';
import { WithColor } from '@styles/colors';
import { UtilizationItemProps } from '@v2/pages/machines/common/types/props';

interface LineProps extends WithColor {
  width: number;
  maxWidth: number;
  colorTime: string;
  backgroundColor: string;
}

const Line = ({ width, maxWidth, colorTime, backgroundColor, C }: LineProps) => {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <View
        style={{
          height: scale(16),
          paddingHorizontal: scale(1),
          borderRadius: scale(3),
          justifyContent: 'center',
          width: maxWidth * width,
          backgroundColor: C(backgroundColor),
        }}
      />
      <Text style={{ color: C(colorTime), marginLeft: scale(4) }} numberOfLines={1}>
        <Text style={[font['Button 3']]}>{Number((width * 100).toFixed(2))}</Text>
        <Text style={[font.Small]}>%</Text>
      </Text>
    </View>
  );
};

interface ItemOEETimeProps extends UtilizationItemProps {}

export default ({ item, C, selected, maxWidth = isWeb ? 160 : 190, paddingLeft = 5.5 }: ItemOEETimeProps) => {
  // do not render OEE bars for machines without data in the selected period (in left sidebar)
  if (item?.hasNoDataInPeriod || !item?.machineOEE) {
    return null;
  }

  return (
    <View style={{ width: '100%', paddingLeft: scale(paddingLeft), zIndex: 0 }}>
      <View style={{ marginTop: scale(2) }}>
        <Line
          {...{
            colorTime: selected ? 'OEE/Light/OEE' : 'OEE/Light/OEE Chart',
            backgroundColor: selected ? 'OEE/Light/OEE' : 'OEE/Light/OEE Chart',
            width: item?.machineOEE?.oee,
            maxWidth,
            C,
          }}
        />
      </View>
      <View style={{ marginTop: scale(7) }}>
        <Line
          {...{
            colorTime: selected ? 'OEE/Light/TEEP' : 'OEE/Light/TEEP',
            backgroundColor: selected ? 'OEE/Light/TEEP' : 'OEE/Light/TEEP',
            width: item?.machineOEE?.teep,
            maxWidth,
            C,
          }}
        />
      </View>
    </View>
  );
};
